<template>
  <div>
    <div class="container-fluid login">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-10 col-sm-8 mx-auto login-form">

            <router-link to="/" class="content-logo-principal">
              <div style="display:flex;justify-content:center;align-items:center">
                <h1 class="logo-name style-scope page-auth-login">
                  <a href="https://royalpag.com/">
                         <img :src="img" style="width: 250px">
                  </a></h1>
              </div>
            </router-link>
            <h2 class="text-center text-default-gray logo_h2" style="font-size: 16px; font-family: Roboto;">
              Esqueceu (ou trocar) a senha?
            </h2>
            <p class="text-center text-default-gray" style="font-size: 14px; font-family: Roboto; margin-bottom: 0px !important;">Informe o e-mail cadastrado para redefinir sua senha. A ações adicionais serão enviadas para o endereço informado.</p>
            <div class="card-body pt-3">
              <div class="row">
                <div class="col-12">                  
                  <form class="well" @submit.prevent="submit">
                    <div class="form-group">
                      <input name="email_registrado" type="text" autocomplete="username" required autofocus placeholder="Informe e-mail registrado" class="form-control" v-model="usuario.email" />
                    </div>
<!--                    <div class="form-group">-->
<!--                      <input name="verique_email" type="password" required autofocus placeholder="Informe novamente o e-mail" class="form-control"/>-->
<!--                    </div>-->
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <input type="submit" value="Recuperar Senha" :style="color" class="btn btn-primary btn-block"/>                          
                        </div>
                        <div class="form-group">
                          <span style="padding-left: 15px">Lembrou a senha? <router-link to="/auth/login" exact>Voltar</router-link></span>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import site_style from '@/service/site_style'

  export default {
    name: 'Register',
    computed: {
      ...mapState('perfis', {
        perfis (state) {
          return this.orderBy(state.list, 'nome', 1)
        }
      }),
      ...mapState('tiposUsuarios', {
        tiposUsuarios (state) {
          return state.list
        }
      }),
      ...mapState(['logo'])
    },
    mounted () {
      this.fetchPerfis()
      this.fetchTiposUsuarios()
    },
    data () {
      return {
        img: site_style.getLogo().default,
        color: site_style.getColor(),
        perfisSelecionadas: [],
        tipoUsuarioSelecionado: null,
        usuario: {
          id: 0,
          nome: '',
          email: '',
          login: '',
          senha: '',
          idTipoUsuario: 0,
          descricaoTipoUsuario: '',
          perfisId: []
        }
      }
    },
    methods: {
      ...mapActions('usuarios', ['solicitarRedefinicaoSenha']),
      ...mapActions('perfis', {
        fetchPerfis: 'fetch'
      }),
      ...mapActions('tiposUsuarios', {
        fetchTiposUsuarios: 'fetch'
      }),
      setTipoUsuario () {
        this.tiposUsuarios.forEach((tu) => {
          if (tu.descricao === 'Usuário') {
            this.usuario.descricaoTipoUsuario = tu.descricao
            this.usuario.idTipoUsuario = tu.id
          }
        })
      },
      setPerfil () {
        this.perfis.forEach((perfil) => {
          if (perfil.nome === 'VP') {
            this.usuario.perfisId.push(perfil.id)
          }
        })
      },
      async submit () {
        this.setPerfil()
        this.setTipoUsuario()
        const verb = 'post'
        const { usuario } = this
        this.solicitarRedefinicaoSenha({ verb, usuario }).then(() => {
          console.log('router auth.login')
          this.$router.push({ path: '/auth/login' })
        })
        console.log('fim')
      }
    }
  }
</script>

<style src="../../assets/css/login.css" scoped></style>
<style scoped>
  .top25 {
    margin-top: 25px;
  }
  .login {
    padding-top: 6.5%;
    padding-bottom: 2%;
    width: 100%;
    height: 100vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /* background: radial-gradient(ellipse at center, #5A93AF 0%, #004E74 100%); */
    background-color: #eee;
    overflow-y: auto;
  }
  .submit-btn {
    background-color: rgba(255,255,255, .2);
  }
</style>




// WEBPACK FOOTER //
// index.vue?51b6ff5d